import { render, staticRenderFns } from "./BigClient.vue?vue&type=template&id=6034c55a&scoped=true&"
import script from "./BigClient.vue?vue&type=script&lang=js&"
export * from "./BigClient.vue?vue&type=script&lang=js&"
import style0 from "./BigClient.vue?vue&type=style&index=0&id=6034c55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6034c55a",
  null
  
)

export default component.exports